import request from '@/utils/request'


// 交易记录查询
export const queryTransactionList = (params) => {
  return request({
    url: '/tinggoadmin/finance/transaction/list',
    method: 'get',
    params
  })
}

// 交易记录详情
export const queryTransactionDetail = (flowNo) => {
  return request({
    url: `/tinggoadmin/finance/transaction/detail/${flowNo}`,
    method: 'get'
  })
}

